import { render } from "./news-item.vue?vue&type=template&id=04bb9371&scoped=true"
import script from "./news-item.vue?vue&type=script&lang=js"
export * from "./news-item.vue?vue&type=script&lang=js"

import "./news-item.vue?vue&type=style&index=0&id=04bb9371&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bb9371"]])

export default __exports__